<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div
  class="d-flex flex-column"
  #xterm
  [hidden]="loading"
  class="container"
  [style.width.px]="width"
  [style.height.px]="height"
>
  <span
    #dragHandleBottom
    cdkDragLockAxis="y"
    class="dragHandle bottom"
    cdkDrag
    (cdkDragMoved)="dragMove(dragHandleBottom)"
  >
    <mat-icon
      class="drag-icon mdi-24px"
      fontIcon="mdi-drag-horizontal-variant"
      matTooltip="Drag to resize"
      [matTooltipShowDelay]="1000"
    ></mat-icon>
  </span>
</div>
<div>
  <button
    aria-label="Fullscreen"
    matTooltip="Fullscreen"
    [matTooltipShowDelay]="1000"
    mat-icon-button
    (click)="fullscreen()"
  >
    <mat-icon class="mdi-24px" fontIcon="mdi-fullscreen"></mat-icon>
  </button>
</div>
